(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('voiceInputConstants', {
            VOICE: {
                RECORDING: 'recording',
                AI: 'ai',
                GENERAL: 'general',
                TRANSCRIBE: 'transcribe',
                CHOOSE: 'choose',
                PROCESSING: 'processing',
                FILE: 'file',
                CONTEXT: 'context',
                FALLBACK_AUDIO_TYPE: 'audio/webm'
            },
            ERROR: {
                NOT_ALLOWED_ERROR: 'NotAllowedError',
                PERMISSION_DENIED_ERROR: 'PermissionDeniedError',
                NOT_FOUND_ERROR: 'NotFoundError',
                DEVICES_NOT_FOUND_ERROR: 'DevicesNotFoundError',
                NOT_READABLE_ERROR: 'NotReadableError',
                TRACK_START_ERROR: 'TrackStartError'
            },
            TIME: {
                ELAPSED_SECONDS_INIT: 0,
                ELAPSED_SECONDS_INTERVAL: 0.2,
                MAX_SECONDS: 57,
                PROGRESS_PERCENT_INIT: 0
            }
        });
})();
